<template>
  <div class="mb-4">
    <label
      for="approvals-create-template-select"
      class="text-body-3 text-textDarkest d-block mb-1"
    >
      Approval Template
    </label>
    <v-select
      id="approvals-create-template-select"
      v-model="selectedTemplateUlid"
      :items="items"
      item-title="name"
      item-value="ulid"
      density="compact"
      variant="outlined"
      rounded="lg"
      color="primary"
      menu-icon="$chevron-down"
      hide-details
      placeholder="Select approval template"
      class="approvals-create-template-select text-body-1"
      :menu-props="{ contentClass: 'approvals-create-template-select-menu' }"
      :disabled="!items.length"
    >
      <template #selection>
        <ApprovalTemplateSelectOption
          v-if="selectedTemplate"
          :template="selectedTemplate"
          compact
        />
        <span
          v-else
          class="text-body-1 text-textDark"
        >Select approval template</span>
      </template>

      <template #item="{ props: itemProps, item }">
        <v-list-item
          v-bind="itemProps"
          class="approvals-create-template-select-item"
        >
          <ApprovalTemplateSelectOption :template="item.raw" />
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ApprovalTemplateSelectOption from '@/components/jobProfiles/editor/ApprovalTemplateSelectOption.vue';

const props = defineProps({
  items: { type: Array, default: () => ([]) },
  modelValue: { type: String, default: '' },
  selectedTemplate: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['update:model-value']);

const selectedTemplateUlid = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:model-value', value),
});
</script>

<style lang="less" scoped>
.approvals-create-template-select {
  :deep(.v-field__append-inner .v-icon) {
    color: @text-dark;
  }

  :deep(.v-field) {
    color: @text-darkest;
    min-height: 72px;
    align-items: center;
  }

  :deep(.v-field__input) {
    min-height: 72px;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  :deep(.v-select__selection--placeholder) {
    color: @text-dark;
  }
}
</style>

<style lang="less">
.approvals-create-template-select-menu.v-overlay__content > .v-list {
  box-shadow: none;
  border: 1px solid @stroke-default;
  border-radius: 8px;
  background-color: @bg-default;
}

.approvals-create-template-select-menu .v-list-item {
  padding: 12px 16px;
  min-height: unset;
}

.approvals-create-template-select-menu .v-list-item-title {
  display: none;
}
</style>
